import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { useLangFile } from '../../../../context/LanguageContext';

interface BulkPrescriptionApplyIntervalsDialogProps {
  open: boolean;
  onSetOpen: (open: boolean) => void;
  onConfirmSetAppliedInitialIntervals: () => void;
}

const BulkPrescriptionApplyIntervalsDialog: React.FC<BulkPrescriptionApplyIntervalsDialogProps> = ({
  open,
  onSetOpen,
  onConfirmSetAppliedInitialIntervals,
}) => {
  const LangFile = useLangFile();

  const onConfirm = () => {
    onConfirmSetAppliedInitialIntervals();
    onSetOpen(false);
  };

  return (
    <Dialog
      data-testid="bulk-apply-intervals-dialog"
      open={Boolean(open)}
      fullWidth
      maxWidth={'md'}
    >
      <DialogTitle>{LangFile.BulkPrescriptionApplyIntervalsDialog.title}</DialogTitle>

      <DialogContent style={{ overflow: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {LangFile.BulkPrescriptionApplyIntervalsDialog.info}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onSetOpen(false)} color={'inherit'} variant={'outlined'}>
          {LangFile.BulkPrescriptionApplyIntervalsDialog.cancel}
        </Button>
        <Button
          data-testid="bulk-apply-intervals-confirm"
          onClick={() => onConfirm()}
          color="primary"
          variant="contained"
        >
          {LangFile.BulkPrescriptionApplyIntervalsDialog.apply}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkPrescriptionApplyIntervalsDialog;
